module.exports = __webpack_public_path__ + "img/51dda50.jpg";